import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@material-ui/core';
import c from 'classnames';
import { getStaticText } from '../../../../utils/constants';
import getStaticTextDiagnose from '../../constants';
import Info from '../../assets/C-info.svg';
import '../index.scss';
import { getEEBoxStyle } from '../../../../utils/functions';
import MetaChartModal from '../../MetaChartModal';
import SelectModal from '../../../../components/SelectModal';
import FilterSvg from '../../assets/Filter.svg';
import ActiveFilters1 from '../../assets/ActiveFilters1.svg';
import BulletList from '../../assets/BulletList.svg';
import Down from '../../assets/Down.svg';
import colors from '../../../../sass/colors';
import DonutChart from '../../../../components/DonutChart/DonutChart';
import { getIndExpSectionHeading, isIndExpSubTabHidden } from '../indExperiencePublicSector';

const showProgress = (value, background, isNegative, applyEx, key, isTopQuartile, isPercentile, isNonProfit, ohid) => {
    const { positiveBg = '#000000', negativeBg = '#ffffff' } =
        getEEBoxStyle(value, isNegative, isNonProfit, ohid) || {};
    const noBmBg = isNegative ? negativeBg : positiveBg;
    const bgToUse = applyEx ? background : noBmBg;

    const isEnps = key === 'endorsing_organization_to_others' && applyEx && !isPercentile;

    const percentage = isEnps ? ((value + 100) * 100) / 200 : value;

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', flexWrap: 'wrap' }}>
            <div className="progress-bar">
                <DonutChart
                    background={bgToUse}
                    value={percentage}
                    displayValue={isEnps ? value : `${value}%`}
                    isTopQuartile={applyEx && isTopQuartile}
                />
                {/* {isTopQuartile && applyEx ? <div className="triangle" /> : null} */}
            </div>
        </Box>
    );
};

function EmpExpScorecard({
    qbyqData,
    defaultSettings,
    apiLoadingCount,
    errorInfo,
    projects,
    projectsFetched,
    resurveyModal,
    setReSurveyModal,
    callReSurveyApi,
    setReport,
    selectedIds,
    addOnTab,
    setAddOnTabs,
    appliedFiltersInfo,
    toggleFilterView,
    pptDownload,
    activeResetFilter,
    appliedBenchmark,
    footnoteList,
    getComparisonYearSettings,
    compYrSettings,
    compType,
    compTypeFetched,
    getCompType,
}) {
    const {
        lang = '1033',
        report_type: surveyType = '',
        quartileColors = [],
        apply_employee_exp_benchmark = false,
        engagement = '',
        ohid,
        is_public_sector_ohi = false,
    } = defaultSettings;
    const staticTextDiagnose = getStaticTextDiagnose(lang);
    const { QUESTIONS, PS_QUESTIONS } = staticTextDiagnose;
    const questionsToUse = is_public_sector_ohi ? PS_QUESTIONS : QUESTIONS;
    const staticText = getStaticText(lang);
    const {
        NEG_IND_QUES,
        QUES_LEGEND_TYPE,
        SITE_TEXT,
        IND_EXP_SCORE_CLASSIFICATION,
        NON_PROFIT_SURVEY,
        BRADESCO_IND_EXP_SCORE_CLASSIFICATION,
        BRADESCO_2025,
    } = staticText;
    const [showMetaChart, setShowMetaChart] = useState(false);
    const [metaData, setMetaData] = useState({});
    const [isPracticeMeta, setPraticeMeta] = useState(false);
    const isNonProfit = engagement === NON_PROFIT_SURVEY;
    const isBraidesco = BRADESCO_2025.includes(ohid);
    const indExpScoreClassification = isBraidesco
        ? BRADESCO_IND_EXP_SCORE_CLASSIFICATION
        : IND_EXP_SCORE_CLASSIFICATION;
    const toggleMetaDataPopup = (modalState = false, scores = {}, isPractice = false) => {
        setShowMetaChart(modalState);
        setMetaData(scores);
        setPraticeMeta(isPractice);
    };

    const { records: qbyq = {}, size = '' } = qbyqData || {};
    const {
        fe_ee_factor_pc_fv_ps,
        fe_ee_factor_pc_fv,
        com_ee_neg_enps_pc_fv,
        com_ee_enps_calc_detail_pc_fv,
        com_ee_neg_enps_pc_fv_ps,
        fe_ee_factor_percentile,
        com_ee_enps_calc_detail_percentile,
        com_ee_neg_enps_percentile,
    } = footnoteList || {};
    const checkLength = !!Object.keys(qbyq).length;
    const {
        SINGLE_QUESTIONS_LEGEND,
        QUESTION_SCORE,
        IND_EXP_SCORE_PAGE_TEXT_NOTES,
        // EMPLOYEE_NET_PROMOTER_SCORE,
        EE_PERCENT_FAVORABLE,
        // EE_PERCENTILE,
        NOTE,
        IND_EXP_QUESTION_NOTE,
        IND_EXP_LINKS,
        FILTERS,
        DOWNLOAD,
        NUMBER_OF_RESPONDENTS_N,
        EMPLYEE_EXPEIENCE,
        RESURVEY_TEXT,
        EMPLOYEE_FACTORS_POSITIVE,
        EMPLOYEE_FACTORS_NEGATIVE,
        EE_ENPS_FOOTER,
        BENCHMARK_NA,
        BOTTOM_DECILE,
        BENCHMARK_HEAD,
        NO_BENCHMARK,
        ADDITIONAL_PRACTICES,
    } = SITE_TEXT || {};

    const sectionHeading = getIndExpSectionHeading(is_public_sector_ohi, EMPLYEE_EXPEIENCE, ADDITIONAL_PRACTICES);

    const selectProject = (ohId, reportType, applyExBenchMark) => {
        setReSurveyModal(false);
        callReSurveyApi([ohId], 0, applyExBenchMark);
        setReport(reportType);
    };

    // const renderRightOptions = () => {
    //     const { demographics = [] } = filters[0] || {};
    //     // if (addOnTab === 1) {
    //     //     return (
    //     //         <div className="outcomeContent">
    //     //             <ul className="questionLegends">
    //     //                 <li>{FREQUENCY_LEVEL_PERCENT}</li>
    //     //                 {IND_QUES_LEGEND.map(legendText => (
    //     //                     <li>
    //     //                         <span />
    //     //                         {legendText}
    //     //                     </li>
    //     //                 ))}
    //     //             </ul>
    //     //         </div>
    //     //     );
    //     // }
    //     // if (addOnTab < 2 || (addOnTab === 3 && crossTabDemo !== DEFAULT_STATE)) return null;
    //     return (
    //         <div className="rightOptions">
    //             <span>
    //                 <Select
    //                     IconComponent={KeyboardArrowDownSharpIcon}
    //                     value={selectedDemographics}
    //                     MenuProps={{
    //                         anchorOrigin: {
    //                             vertical: 'bottom',
    //                             horizontal: 'left',
    //                         },
    //                         transformOrigin: {
    //                             vertical: 'top',
    //                             horizontal: 'left',
    //                         },
    //                         getContentAnchorEl: null,
    //                     }}
    //                     onChange={({ target: { value: code } }) => {
    //                         setSelectedDemographic(code);
    //                         callHeatMap(code);
    //                     }}
    //                 >
    //                     {demographics.map(({ label, code }) => {
    //                         return (
    //                             <MenuItem classes={{ root: 'demographicOptions' }} key={code} value={code}>
    //                                 {label}
    //                             </MenuItem>
    //                         );
    //                     })}
    //                 </Select>
    //             </span>
    //         </div>
    //     );
    // };

    const oldSelectedId = selectedIds.length ? selectedIds[0] : '';
    let sup = 1;
    const FOOTNOTES =
        surveyType === 'percent favorable' && is_public_sector_ohi
            ? [fe_ee_factor_pc_fv_ps, com_ee_enps_calc_detail_pc_fv, com_ee_neg_enps_pc_fv_ps]
            : surveyType === 'percent favorable'
            ? [fe_ee_factor_pc_fv, com_ee_enps_calc_detail_pc_fv, com_ee_neg_enps_pc_fv]
            : [fe_ee_factor_percentile, com_ee_enps_calc_detail_percentile, com_ee_neg_enps_percentile];

    return (
        <Fragment>
            <div className="scoreBoard addOns clearfix">
                <div className="indExpBoard">
                    <div className="rightScorecardHeader">
                        <div className="scorecardHeading">
                            <div className="mainHeading">
                                {sectionHeading} {resurveyModal ? 'Resurvey' : ''}
                                <sup>{sup}</sup>
                            </div>
                            <div className="nRes">
                                {NUMBER_OF_RESPONDENTS_N} : <span>{size.toLocaleString('en-US')}</span>
                            </div>
                        </div>
                        <ul className="navScoreList">
                            {!is_public_sector_ohi ? (
                                <li
                                    data-testid="setReSurveyModalBtn"
                                    onClick={() => setReSurveyModal(true)}
                                    className="fImage resurveyImg"
                                >
                                    <img src={BulletList} alt="" />
                                    <span className="upperHead">{RESURVEY_TEXT}</span>
                                </li>
                            ) : null}
                            {!errorInfo && (
                                <li data-testid="getPptBtn" onClick={pptDownload} className="resurveyImg">
                                    <img src={Down} alt="" />
                                    <span className="lineHead upperHead">{DOWNLOAD}</span>
                                </li>
                            )}
                            <li onClick={() => toggleFilterView(true)} data-testid="filterButton">
                                <img src={activeResetFilter ? ActiveFilters1 : FilterSvg} alt="" />
                                <span className="filter">{FILTERS}</span>
                            </li>
                        </ul>
                    </div>
                    {appliedFiltersInfo()}
                    {appliedBenchmark()}

                    <div className={`optionWrapper ${addOnTab === 1 ? 'stickyTop' : ''}`}>
                        <div>
                            <ul className="leftNav">
                                {IND_EXP_LINKS.map((tabName, index) => {
                                    if (
                                        isIndExpSubTabHidden(index, is_public_sector_ohi) ||
                                        (!apply_employee_exp_benchmark && index === 4) ||
                                        (surveyType === 'percentile' && index === 4)
                                    )
                                        return null;
                                    return (
                                        <li
                                            data-testid={tabName}
                                            key={tabName}
                                            className={c({ activeLink: addOnTab === index })}
                                            onClick={() => setAddOnTabs(index)}
                                        >
                                            {tabName}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        {/* {renderRightOptions()} */}
                    </div>
                    <Fragment>
                        <div className={c('indExpScorecard', { indExpScorecardPsOhi: is_public_sector_ohi })}>
                            {checkLength &&
                                questionsToUse.map(({ title, children, imgSrc }) => {
                                    return (
                                        <div className="cardWrapper">
                                            <div className="headerContent">
                                                <h2>
                                                    <span>
                                                        <img src={imgSrc} alt={title} />
                                                    </span>
                                                    {title}
                                                </h2>
                                            </div>
                                            {children.map(key => {
                                                const {
                                                    quartile,
                                                    range_start,
                                                    range_end,
                                                    display_name: childTitle = '',
                                                    score,
                                                    meta_scores = [],
                                                } = qbyq[key] || {};
                                                const negativeTrait = NEG_IND_QUES.includes(key);
                                                sup = QUES_LEGEND_TYPE[key] || '';
                                                const {
                                                    qtext = '',
                                                    bottom2_score = 0,
                                                    nuetral_score = 0,
                                                    score: metaScore = 0,
                                                } = meta_scores[0] || {};
                                                // const enps = metaScore - bottom2_score;
                                                // const positiveNps = enps > 0;
                                                const childSet = {
                                                    meta_scores,
                                                    display_name: childTitle,
                                                    score,
                                                    quartile,
                                                    range_start,
                                                    range_end,
                                                };
                                                const TITLE = 'Recomendar la organización ante otros';
                                                const titleToUse =
                                                    lang === '10' && key === 'endorsing_organization_to_others'
                                                        ? TITLE
                                                        : childTitle;
                                                const { background = '#ffffff' } = quartileColors[quartile] || {};
                                                if (isNaN(parseInt(score, 10))) return null;
                                                return (
                                                    <div className={c({ hoverElement: sup === 2 }, 'cardData')}>
                                                        <div onClick={() => toggleMetaDataPopup(true, childSet, false)}>
                                                            {titleToUse}
                                                            <sup>{sup}</sup>
                                                            {sup === 2 ? (
                                                                <span>
                                                                    <img src={Info} alt="" />
                                                                </span>
                                                            ) : null}
                                                        </div>

                                                        <div className="percentProgress">
                                                            {showProgress(
                                                                score,
                                                                background,
                                                                negativeTrait,
                                                                apply_employee_exp_benchmark,
                                                                key,
                                                                parseInt(quartile, 10) === 0,
                                                                surveyType === 'percentile',
                                                                isNonProfit,
                                                                ohid
                                                            )}
                                                        </div>
                                                        {sup === 2 ? (
                                                            <div className="detailedInfo">
                                                                <div className="questionSection">
                                                                    <div className="practiceSet clearfix">
                                                                        <div className="metaSection">
                                                                            <div className="metaText">
                                                                                <b>{QUESTION_SCORE}</b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="practiceSet clearfix">
                                                                        <div className="metaSection">
                                                                            <div className="metaText">{qtext}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="metaInfo">
                                                                        {IND_EXP_SCORE_PAGE_TEXT_NOTES}
                                                                    </div>
                                                                    <div className="practiceSet clearfix">
                                                                        <div className="metaSection">
                                                                            <div className="metaText">
                                                                                <div className="metaScore chart">
                                                                                    <div className="chartLegends">
                                                                                        {SINGLE_QUESTIONS_LEGEND.map(
                                                                                            legendText => {
                                                                                                return (
                                                                                                    <div>
                                                                                                        <span />{' '}
                                                                                                        {legendText}
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="metaScore">
                                                                                <div className="chart">
                                                                                    <span
                                                                                        style={{
                                                                                            width: `${bottom2_score}%`,
                                                                                        }}
                                                                                    >
                                                                                        {bottom2_score}
                                                                                    </span>
                                                                                    <span
                                                                                        style={{
                                                                                            width: `${nuetral_score}%`,
                                                                                        }}
                                                                                    >
                                                                                        {nuetral_score}
                                                                                    </span>
                                                                                    <span
                                                                                        style={{
                                                                                            width: `${metaScore}%`,
                                                                                        }}
                                                                                    >
                                                                                        {metaScore}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                            {showMetaChart && (
                                <MetaChartModal
                                    metaData={metaData}
                                    closeModal={toggleMetaDataPopup}
                                    isPracticeMeta={isPracticeMeta}
                                    totalSize={size.toLocaleString('en-US')}
                                    defaultSettings={defaultSettings}
                                    isEE={!apply_employee_exp_benchmark}
                                    ohid={ohid}
                                />
                            )}
                            {resurveyModal && (
                                <SelectModal
                                    defaultSettings={defaultSettings}
                                    oldSelectedId={oldSelectedId}
                                    projects={projects}
                                    projectsFetched={projectsFetched}
                                    closeModal={setReSurveyModal}
                                    selectProject={selectProject}
                                    practiceRankModal
                                    getComparisonYearSettings={getComparisonYearSettings}
                                    compYrSettings={compYrSettings}
                                    apiLoadingCount={apiLoadingCount}
                                    isExModule
                                    compType={compType}
                                    compTypeFetched={compTypeFetched}
                                    getCompType={getCompType}
                                />
                            )}
                        </div>

                        {!apiLoadingCount && !errorInfo && (
                            <Fragment>
                                {apply_employee_exp_benchmark ? (
                                    <div className="note">
                                        <b>{NOTE}:</b>
                                        {FOOTNOTES.map((txt, i) => {
                                            return <div>{`${i + 1}. ${txt}`}</div>;
                                        })}
                                    </div>
                                ) : (
                                    <div className="note">
                                        <b>{NOTE}:</b>
                                        <div>1. {EE_PERCENT_FAVORABLE}</div>
                                        {IND_EXP_QUESTION_NOTE[0]}
                                        <br />
                                        {IND_EXP_QUESTION_NOTE[1]}
                                        <div>4. {EE_ENPS_FOOTER}</div>
                                    </div>
                                )}
                            </Fragment>
                        )}
                    </Fragment>
                </div>
            </div>
            <ul className="fixedScoreCardSurvey">
                {apply_employee_exp_benchmark ? (
                    <ul className="benchmark clearfix">
                        <li>{BENCHMARK_HEAD} : </li>
                        {quartileColors
                            .slice()
                            .reverse()
                            .map(({ title, background, border: borderColor }) => {
                                const bottomDecileVar = title === BOTTOM_DECILE;
                                const BenchmarkTitle = title === NO_BENCHMARK;
                                return (
                                    <li
                                        key={title}
                                        style={{ color: background }}
                                        className={c({
                                            hide: bottomDecileVar || BenchmarkTitle,
                                        })}
                                    >
                                        <span
                                            className="benchmarkTriangle"
                                            style={{
                                                background,
                                                borderWidth: '2px',
                                                border: `${borderColor}`,
                                                borderStyle: 'solid',
                                            }}
                                        />
                                        <div style={{ color: 'black' }}>{title}</div>
                                    </li>
                                );
                            })}
                        <li>
                            <span style={{ background: colors.$white, border: '1.5px solid #e6e6e6' }} />
                            {BENCHMARK_NA}
                        </li>
                    </ul>
                ) : (
                    <Fragment>
                        <ul className="benchmark clearfix">
                            <li>{EMPLOYEE_FACTORS_POSITIVE} : </li>
                            {indExpScoreClassification.map(({ title, positiveBg: background }) => (
                                <li key={title}>
                                    <span style={{ background, border: 'none' }} />
                                    {title}
                                </li>
                            ))}
                        </ul>
                        <ul className="benchmark clearfix">
                            <li>{EMPLOYEE_FACTORS_NEGATIVE} : </li>
                            {indExpScoreClassification.map(({ titleNeg, title, negativeBg: background }) => (
                                <li key={titleNeg}>
                                    <span style={{ background, border: 'none' }} />
                                    {isNonProfit ? title : titleNeg}
                                </li>
                            ))}
                        </ul>
                    </Fragment>
                )}
            </ul>
        </Fragment>
    );
}

EmpExpScorecard.propTypes = {
    defaultSettings: PropTypes.object.isRequired,
    qbyqData: PropTypes.object.isRequired,
    apiLoadingCount: PropTypes.number.isRequired,
    errorInfo: PropTypes.number.isRequired,
    projects: PropTypes.array.isRequired,
    projectsFetched: PropTypes.bool.isRequired,
    resurveyModal: PropTypes.bool.isRequired,
    setReSurveyModal: PropTypes.func.isRequired,
    callReSurveyApi: PropTypes.func.isRequired,
    setReport: PropTypes.func.isRequired,
    selectedIds: PropTypes.array.isRequired,
    appliedFiltersInfo: PropTypes.func.isRequired,
    toggleFilterView: PropTypes.func.isRequired,
    pptDownload: PropTypes.func.isRequired,
    activeResetFilter: PropTypes.bool.isRequired,
    setAddOnTabs: PropTypes.func.isRequired,
    addOnTab: PropTypes.number.isRequired,
    appliedBenchmark: PropTypes.func.isRequired,
    footnoteList: PropTypes.array.isRequired,
    getComparisonYearSettings: PropTypes.func.isRequired,
    compYrSettings: PropTypes.object.isRequired,
    compType: PropTypes.object.isRequired,
    compTypeFetched: PropTypes.bool.isRequired,
    getCompType: PropTypes.func.isRequired,
};

export default EmpExpScorecard;
